import PropTypes from 'prop-types';
import React from 'react';
import { red500 } from 'apps/new-web/views/themes/colors';

const defaultStyles = {
  display: 'inline-block',
  fontSize: '12px',
  lineHeight: '12px',
  position: 'relative',
};

const ErrorMessage = (props, context) => {
  const styles = Object.assign({}, defaultStyles, { color: red500 }, props.style);

  return (
    <span style={ styles }>{ props.children }</span>
  );
};

ErrorMessage.contextTypes = { muiTheme: PropTypes.object };

ErrorMessage.propTypes = {
  style: PropTypes.object
};

export default ErrorMessage;
